module.exports = __webpack_require__.p + "0454652a956d748a0114ac0e42058631.jpg";